/**
 * @fileoverview Supported Shopify themes manifest
 * @see src/expPlatform/embeds/integrations/shopify/integrations/README.md
 * for directory structure and path meanings
 * All file paths are relative to src/expPlatform/embeds/integrations/shopify/integrations/themes
 */
export const supportedThemes = {
    Dawn: {
        // quick-add-modal standard (supported)
        default: ['Shopify/default', 'Shopify/Dawn/quickView'],
    },
    // quick-add-modal standard + bulk (not supported)
    Refresh: {
        default: ['Shopify/default'],
    },
    // quick-add-modal standard + bulk (not supported)
    Craft: {
        default: ['Shopify/default'],
    },
    // quick-add-modal standard + bulk (not supported)
    Spotlight: {
        default: ['Shopify/default'],
    },
    // quick-add-modal standard + bulk (not supported)
    Trade: {
        default: ['Shopify/default'],
    },
    // quick-add-modal standard + bulk (not supported)
    Sense: {
        default: ['Shopify/default'],
    },
    Prestige: {
        default: ['Maestrooo/default', 'Maestrooo/Prestige/quickView'],
    },
    Impact: {
        default: ['Maestrooo/default'],
    },
    Ella: {
        default: ['Halo/default'],
        '6.7.2': ['Halo/default'],
        '6.7.1': ['Halo/default'],
        // 6.6.1 has window.sharedFunctions but not updateSidebarCart
    },
    Impulse: {
        default: ['Archetype/default'],
    },
};
